module.exports = __webpack_public_path__ + "img/loader1.gif";